import React from 'react'

import { useMessage } from '../../hooks/message'
import { usePostRequest } from '../../hooks/request'
import { SALARY_LIST } from '../../urls'
import SalaryMarkForm from './SalaryMarkForm'

export default function SalaryMarkCreate({ onCancel, categoryList, expenseReport, brandList, category, employeeId }) {
    const products = usePostRequest({ url: SALARY_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success, error } = await products.request({ data: { ...data, assigned: employeeId } })
        if (success) {
            expenseReport.request()
            category.request()
            onCancel()
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Белгилаш</b>
            </h1>
            <SalaryMarkForm loading={products.loading} categoryList={categoryList} brandList={brandList}
                onCancel={onCancel}
                onSubmit={onSubmit} />
        </div>
    )
}
